import Reflux from "reflux";
import { SystemLicenses } from "@graylog/enterprise-api";
import { LICENSE_SUBJECTS } from "license/constants";
import whenLoggedIn from "common/whenLoggedIn";
const ViewsLicenseActions = Reflux.createActions({ status: { asyncResult: true } });
const ViewsLicenseStore = Reflux.createStore({
  listenables: [ViewsLicenseActions],
  getInitialState() {
    return this._status;
  },
  init() {
    this._status = {
      status: void 0,
      missing: true,
      loading: true
    };
    whenLoggedIn(() => this.status());
  },
  status() {
    const promise = SystemLicenses.validityForSubject(LICENSE_SUBJECTS.views).then(
      (response) => {
        this._status = { status: response, missing: false, loading: false };
        return this._status;
      },
      (error) => {
        var _a, _b, _c;
        const status = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.status;
        if (status === 404) {
          this._status = { status: void 0, missing: true, loading: false };
        } else {
          const errorMessage = ((_c = (_b = error == null ? void 0 : error.additional) == null ? void 0 : _b.body) == null ? void 0 : _c.message) || (error == null ? void 0 : error.message);
          this._status = { status: void 0, missing: true, loading: false, error: errorMessage };
        }
        return this._status;
      }
    );
    promise.then((result) => this.trigger(result));
    ViewsLicenseActions.status.promise(promise);
    return promise;
  }
});
export { ViewsLicenseStore, ViewsLicenseActions };
